module.exports = "<div id=\"3d-viewer\" class=\"page-layout simple fullwidth\" fusePerfectScrollbar>\r\n\r\n    <!-- HEADER -->\r\n    <fuse-selector [pantalla]=\"'3d-viewer'\" [idItem]=\"idActivo\"></fuse-selector>\r\n    <!-- / HEADER -->\r\n    <iframe width=\"100%\" height=\"100%\" style=\"border: 0;flex: 1;\" [src]=\"url | safe\"></iframe>\r\n    <!-- <div class=\"m-56\">\r\n        3d-viewer\r\n    </div> -->\r\n\r\n  </div>\r\n\r\n  <!-- <fuse-panel-info [pantalla]=\"'3d-viewer'\"></fuse-panel-info> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/xd-viewer/xd-viewer.component.html
// module id = ./src/app/main/content/xd-viewer/xd-viewer.component.html
// module chunks = main